import { defineComponent as _defineComponent } from 'vue'
import { onUpdated, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductColorPicker',
  props: {
    colors: { default: () => [] },
    value: { default: null },
    animateAutoChange: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { colors: IColorOption[], value: string, animateAutoChange?: boolean }



const selectedColor = ref<IColorOption>(null);
const selectedColorText = ref<string>('');
const intendedColorChangeText = ref<string>('');

onUpdated(() => {
    const color = props.colors.find(x => x.code === props.value);
    if (color) {
        selectedColor.value = color;
        selectedColorText.value = color.text;
    }
});

function setIntendedColorChangeText(color: IColorOption):void {
    intendedColorChangeText.value = color.text;
}

function getColorOptionInnerStyles(color: IColorOption) {
    return color.image
        ? { backgroundImage: `url('${color.image}')`, backgroundSize: 'contain' }
        : { backgroundColor: color.code };
}

function isColorSelected(color: IColorOption) {
    const selected = color.code === props.value;
    if (selected === true) {
        selectedColor.value = color;
    }
    return selected;
}

return { __sfc: true,props, selectedColor, selectedColorText, intendedColorChangeText, setIntendedColorChangeText, getColorOptionInnerStyles, isColorSelected }
}

})